import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-total-loyer',
    templateUrl: './total-loyer.component.html',
    styleUrls: ['./total-loyer.component.scss']
})
export class TotalLoyerComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
